import {DateTime} from 'luxon';

// Don't use input[type="date"] because browsers that don't support `type=date` won't match it.
const selector = 'input.js-date-validator';

const attributes = {
    min: 'min',
    max: 'max',
    pattern: 'pattern',
};
const cssClasses = {
    error: 'error',
};

/**
 * LegacyDateValidator
 * 
 * <input type="date" class="js-date-validator otherClass1 otherClass2 ..."> class.
 * 
 */
export default class LegacyDateValidator {
    constructor() {
        // Short-circuit if the browser supports `<input type="date">`.
        if (this._browserSupportsInputTypeDate()) {
            return;
        }
        document.addEventListener('DOMContentLoaded', this._init.bind(this));
    }

    _browserSupportsInputTypeDate() {
        const elem = document.createElement('input');

        try {
            elem.type = 'date';
        } catch (err) {
            return false;
        }

        return true;
    }

    _init() {
        const elements = Array.from(document.querySelectorAll(selector));

        if (!elements || !elements.length) {
            return;
        }

        elements.forEach(elem => {
            if(elem.value) {
                const date = DateTime.fromFormat(elem.value, 'yyyy-MM-dd');
                elem.value = date.isValid ? date.toFormat('MM/dd/yyyy') : '';
            }
            elem.addEventListener('change', this._onChange.bind(this));
        });
    }

    _onChange(evt) {
        this._updateUI(evt.target, this._isValid(evt.target));
    }

    _isValid(elem) {
        const input = elem.value.trim();

        if (input === '') {
            return false;
        }

        const pattern = new RegExp(elem.getAttribute(attributes.pattern));
        if (!pattern.test(input)) {
            return false;
        }

        // UI enforces this format for input.
        const dateTime = DateTime.fromFormat(input, 'M/d/yyyy');
        if (!dateTime.isValid) {
            return false;
        }

        // `min` and `max` are in a different format for compatibility with the server-side validation.
        const min = DateTime.fromFormat(elem.getAttribute(attributes.min), 'yyyy-MM-dd');
        const max = DateTime.fromFormat(elem.getAttribute(attributes.max), 'yyyy-MM-dd');

        // If there is no valid `min` or `max` constraint, then any date works.
        if (!min.isValid && !max.isValid) {
            return true;
        }

        // If there is a `min` constraint, then ensure date is not less than it.
        if (min.isValid && dateTime < min) {
            return false;
        }

        // If there is a `max` constraint, then ensure date is not less than it.
        if (max.isValid && dateTime > max) {
            return false;
        }

        return true;
    }

    _updateUI(elem, isValid) {
        // Intentionally commenting out for now.
        // if (isValid) {
        //     elem.classList.remove(cssClasses.error);
        //     return;
        // }

        // elem.classList.add(cssClasses.error);
    }
}
